import {type ChangeEventHandler, useCallback, useMemo, useState} from 'react';

import {useEffectWithDeps} from 'src/hooks/useEffectWithDeps';
import {isDeepEqual} from 'src/utils/isDeepEqual';

import type {ResourceView} from '../typedef';

type Props = {
    records: ResourceView[],
};

export const useExpandPresets = ({records}: Props) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(true);
    const allPresetsIds = useMemo(() => {
        return [...new Set(records
            .filter(({recordId}) => JSON.parse(recordId).presetId)
            .map(({recordId}) => JSON.parse(recordId).presetId),
        )];
    }, [records]);
    const [expandedPresetsIds, setExpandedPresetsIds] = useState<string[]>(allPresetsIds);

    const togglePresetsExpansion = useCallback<ChangeEventHandler<HTMLInputElement>>(event => {
        const expanded = event.currentTarget.checked;
        if (expanded) {
            setExpandedPresetsIds(allPresetsIds);
            setIsExpanded(true);
        } else {
            setExpandedPresetsIds([]);
            setIsExpanded(false);
        }
    }, [allPresetsIds]);


    useEffectWithDeps((prev, current) => {
        if (!isDeepEqual({prev: prev.records, current: current.records})) {
            if (isExpanded) {
                setExpandedPresetsIds(allPresetsIds);
            } else {
                setExpandedPresetsIds([]);
            }
        }
    }, {records, isExpanded, allPresetsIds});

    return {
        expandedPresetsIds,
        isExpanded,
        togglePresetsExpansion,
        setExpandedPresetsIds,
        disabled: allPresetsIds.length === 0,
    };
};
